import React, { useState, useEffect } from "react";
import { useQuery } from 'react-query'
import { getResultsRSC } from "data/Querys"
import { isLiveStatus } from "helpers/status";
import Loader from 'components/general/Loader'
import PageHeader from "components/common/PageHeader";
//Results
import RecordsPrototype from "components/general/RecordsPrototype";
import SwaResults from 'components/sports/swa/views/SwaResults'
import PreviousCompetitor from "components/sports/swa/views/PreviousCompetitor";
import CurrentCompetitor from "components/sports/swa/views/CurrentCompetitor";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import NotAvailable from "components/common/NotAvailable";
import Referees from "components/general/Referees";

const getConfigForReferees = () => {
    let config = {
        source: 'official',
        avoidDuplicates: true
    }
    return config
  }

const SwaContext = () => {
    const { mirs_rsc, mirs_competition, mirs_language } = useUrlFriendlyToParameters()
    const [key, setKey] = useState(`1-${mirs_rsc}`);


    //DATA
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['resultsData', mirs_competition, mirs_rsc, mirs_language],
            queryFn: getResultsRSC,
            refetchInterval: 5000,
            staleTime: 5000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            //enabled: !!confCategory
            //onError: (error) =>
            //    console.error(`Something went wrong: ${error.message}`),
        });

    const resultStatus = data?.results?.status?.code;

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if (isError) { return <div >No data available</div>; }
    if (isLoading) { return <Loader />; }

    const isLive = isLiveStatus(resultStatus) ? true : false

    const refereesConf = getConfigForReferees();
    const lastCompetitor = data?.results?.extendedInfos?.find(ei => ei?.ei_code === "LAST_COMP")
    const currentCompetitor = data?.results?.extendedInfos?.find(ei => ei?.ei_code === "CURRENT")

    return (
        <>
            <PageHeader data={data} />
            <div className='mirs-page-container'>
            {data?.records && mirs_competition === 'OG2024' &&
                <RecordsPrototype records={data?.records} forceMobileColumns={['Date', 'Location']} />
            }
            {isLive && (lastCompetitor !== undefined) &&
                <PreviousCompetitor data={data} />
            }
            {isLive && (currentCompetitor !== undefined) &&
                <CurrentCompetitor data={data} />
            }            
            {data?.results
                ? <>
                    <SwaResults data={data} />
                    <Referees data={data?.results?.officials} config={refereesConf}   />
                </>
                : <NotAvailable />
            }
            </div>
        </>
    );
};

export default SwaContext;



